module.exports = __webpack_public_path__ + "media/images/athletes/1451-81099a8ea35f78a5acdd3c8f347b9d19.png";